<template>
  <div
    v-if="showPrompt"
    id="install-button"
    v-draggable="{ onClick: handleClick }"
    class="drag-bubble"
    :style="bubbleStyle"
  >
    <img src="@/assets/commonImg/create_tips_btn.webp" alt="" />
  </div>
  <van-overlay :show="guideModelShow" z-index="9999" @click.stop="guideModelShow = false">
    <div class="guideModelBg" @click.stop>
      <div class="guideModel">
        <h2>Guía general de adición</h2>
        <div class="guideModel__item">
          <img src="@/assets/commonImg/google_logo.webp" alt="" class="guideModel__item__logo" />
          <div>
            <h3>Navegador Chrome</h3>
            <p class="guideModel__item__step">
              Clic " <img src="@/assets/commonImg/guide_icon2.webp" alt="" /> " en la esquina
              superior derecha--Seleccionar “<b>Añadir a la pantalla de inicio</b> “
            </p>
          </div>
        </div>
        <div class="guideModel__item">
          <img src="@/assets/commonImg/firefox_logo.webp" alt="" class="guideModel__item__logo" />
          <div>
            <h3>Navegador Firefox</h3>
            <p class="guideModel__item__step">
              Clic " <img src="@/assets/commonImg/guide_icon2.webp" alt="" /> " en la esquina
              superior derecha--Seleccionar “<b>Añadir a la pantalla de inicio</b> “
            </p>
          </div>
        </div>
        <div class="guideModel__item">
          <img src="@/assets/commonImg/ie_logo.webp" alt="" class="guideModel__item__logo" />
          <div>
            <h3>Navegador Edge</h3>
            <p class="guideModel__item__step">
              Clic " <img src="@/assets/commonImg/guide_icon1.webp" alt="" /> " en la esquina
              superior derecha--Seleccionar “<b>Añadir al celular</b> “
            </p>
          </div>
        </div>
        <img
          src="@/assets/commonImg/icon_close2.webp"
          alt=""
          class="closeBtn"
          @click="guideModelShow = false"
        />
      </div>
    </div>
  </van-overlay>
</template>

<script>
  // import { useUserStore } from '@/store';
  // const userStore = useUserStore();
  export default {
    data() {
      return {
        bubbleStyle: {
          width: '62px',
          height: '62px',
          right: '5px',
          top: '170px',
        },
        deferredPrompt: null,
        showPrompt: false,
        guideModelShow: false,
      };
    },
    mounted() {
      const savedPrompt = localStorage.getItem('deferredPrompt');
      if (savedPrompt) {
        this.deferredPrompt = JSON.parse(savedPrompt);
        this.showInstallPrompt();
      }
      window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt);
      // // 延迟显示以确保PWA检测准确
      // setTimeout(() => {
      //   if (!this.isPWAInstalled()) {
      //     this.showInstallPrompt();
      //   }
      // }, 5000);
      window.addEventListener('load', this.checkLaunchSource);
    },
    methods: {
      checkLaunchSource() {
        // 通用检测方法
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches;

        // iOS专用检测
        const isIOSStandalone = window.navigator.standalone;
        const params = new URLSearchParams(window.location.search);
        const appName = params.get('app'); // 'app1' 或 'app2'
        console.log('appName---', appName);

        if (isStandalone || isIOSStandalone) {
          console.log('应用从主屏幕图标启动');
          // 执行PWA特有逻辑
        } else {
          console.log('通过浏览器访问');
          // 可以显示"添加到主屏幕"提示
        }
      },
      isPWAInstalled() {
        return (
          window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone
        );
      },
      showInstallPrompt() {
        if (this.isPWAInstalled()) {
          return;
        }
        this.showPrompt = true;
      },
      async handleInstall() {
        console.log('this.deferredPrompt----', this.deferredPrompt);

        try {
          if (this.deferredPrompt) {
            this.deferredPrompt.prompt();
            const { outcome } = await this.deferredPrompt.userChoice;
            if (outcome === 'accepted') {
              console.log('用户接受了PWA安装提示');
            } else {
              console.log('用户拒绝了PWA安装提示');
            }
            this.deferredPrompt = null;
            this.dismissPrompt();
          } else {
            this.guideModelShow = true;
            console.log('不支持PWA...');
          }
        } catch (error) {
          this.guideModelShow = true;
          console.log('不支持PWA...');
        }
      },
      dismissPrompt() {
        this.showPrompt = false;
      },
      handleBeforeInstallPrompt(e) {
        console.log('handleBeforeInstallPrompt----', e);
        e.preventDefault();
        this.deferredPrompt = e;
        // userStore.updateDeferredPrompt(e);
        this.showInstallPrompt();
      },

      handleClick() {
        console.log('气泡被点击了');
        this.handleInstall();
      },
    },
    beforeUnmount() {
      // window.removeEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt);
    },
  };
</script>

<style lang="less" scoped>
  .drag-bubble {
    position: fixed;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    transition: all 0.2s ease-out;
  }
  .drag-bubble img {
    width: 100%;
  }

  .drag-bubble.dragging-active {
    transform: scale(1.1);
    transition: none;
  }
  .guideModelBg {
    width: max-width;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-top: 300px;
  }
  .guideModel {
    width: 620px;
    padding: 50px 30px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 32px;
    position: relative;
    h2 {
      font-family: Roboto, Roboto;
      font-weight: 500;
      font-size: 36px;
      color: #201f1d;
      line-height: 44px;
      text-align: center;
    }
    &__item {
      display: flex;
      padding: 30px 20px;
      background: #f6f7f8;
      border-radius: 16px;
      margin-top: 30px;
      &__logo {
        width: 63px;
        height: 63px;
        margin-right: 20px;
      }
      h3 {
        font-family: Roboto, Roboto;
        font-weight: 500;
        font-size: 28px;
        color: #333333;
        line-height: 28px;
        margin-bottom: 10px;
      }
      &__step {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 22px;
        color: #666666;
        line-height: 28px;
        img {
          height: 18px;
        }
        b {
          color: #333;
        }
      }
    }
    .closeBtn {
      width: 40px;
      height: 40px;
      position: absolute;
      bottom: -80px;
      left: calc(50% - 20px);
    }
  }
</style>
